export enum FileType {
  icon = 'icon',
  photo = 'photo',
}
